// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__fY8Ff","title":"ClientInsurance_title__Ispzn","itemText":"ClientInsurance_itemText__wBlcu"};